export function numero(valor) {
  const n = Number(valor || 0);
  return Number.isFinite(n) ? n : 0;
}

export function moeda(valor) {
  return Number(numero(valor).toFixed(2));
}

export function descontoOriginalItemPedido(item) {
  return numero(
    item.descontoOriginalItem ??
      item.descontoProduto ??
      item.DescontoProduto ??
      item.desconto ??
      item.Desconto
  );
}

export function quantidadeOriginalPedido(item) {
  return numero(
    item.quantidadeOriginalPedido ??
      item.QuantidadeOriginalPedido ??
      item.quantidadePedido ??
      item.QuantidadePedido ??
      item.quantidadePendente ??
      item.quantidade ??
      item.Quantidade
  );
}

export function descontoProporcionalItemPedido(item, quantidadeSelecionada) {
  const quantidadeOriginal = quantidadeOriginalPedido(item);
  const descontoOriginal = descontoOriginalItemPedido(item);

  if (quantidadeOriginal <= 0) {
    return moeda(descontoOriginal);
  }

  return moeda((descontoOriginal * numero(quantidadeSelecionada)) / quantidadeOriginal);
}

export function totalItemEntrada(item) {
  const total = numero(item.valorUnitario) * numero(item.quantidade) - numero(item.desconto);
  return moeda(total < 0 ? 0 : total);
}

export function resumoEntrada(itens, acrescimo, descontoGeral) {
  const subtotal = moeda(
    (itens || []).reduce((sum, item) => sum + totalItemEntrada(item), 0)
  );
  const total = subtotal + numero(acrescimo) - numero(descontoGeral);

  return {
    subtotal,
    total: moeda(total < 0 ? 0 : total),
  };
}
